import { Injectable, inject } from '@angular/core';
import {DatePipe} from '@angular/common';
import {StorageService} from './storage.service';
import {format, parseISO, isValid} from 'date-fns';
import {LocalizedText} from '../model/localized-text';
import {UnemploymentPaymentRequest} from '../model/unemployment-payment-request';

@Injectable({
  providedIn: 'root'
})
export class FormatService {
  private storage = inject(StorageService);
  private datePipe = inject(DatePipe);

  private electronicDocumentTypes = [{
    id: 'C3',
    label: 'C3',
  }, {
    id: 'C3.2',
    label: 'C3.2',
  }];

  getTranslatedData(array: LocalizedText[] | null | undefined): string {
    let translatedData = '';
    if (array != null && Array.isArray(array)) {
      const lang = this.storage.getLanguage() || 'nl';
      const item = array.find(i => i.lang === lang);
      if (item && item.value !== undefined) {
        translatedData = item.value;
      } else if (array.length > 0 && array[0].value !== undefined) {
        translatedData = array[0].value;
      }
    }
    return translatedData;
  }

  getRequestType(request: Partial<Pick<UnemploymentPaymentRequest, 'requestTypeDescription' | 'unemploymentNature'>>): string {
    return this.getTranslatedData(request.requestTypeDescription) || request.unemploymentNature || '';
  }

  formatDate(date: string, dateFormat: string = 'MMMM y'): string | null {
    const lang = this.storage.getLanguage();
    return this.datePipe.transform(date, dateFormat, undefined, lang);
  }

  formatCurrency(currency: string): string {
    switch (currency) {
      case 'B':
        return 'BEF';
      default:
        return '€';
    }
  }

  formatMessage(translatedText: string, values: (string | number)[] = []): string {
    let index = 0;
    return translatedText.replace(/{}/g, () => {
      const value = values[index++];
      return (value !== null && value !== undefined) ? String(value) : '';
    });
  }

  formatNumber(result: number | string, fractionDigitNumber: number = 2): string {
    let numericValue: number;

    if (typeof result === 'string') {
      numericValue = parseFloat(result.replace(',', '.'));
    } else {
      numericValue = result;
    }

    if (isNaN(numericValue)) {
      numericValue = 0;
    }

    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: fractionDigitNumber,
      maximumFractionDigits: fractionDigitNumber
    }).format(numericValue);
  }

  parseDate(dateStr: string | null): string {
    if (!dateStr) {
      return format(new Date(), 'yyyy-MM-dd');
    }

    const parsedISO = parseISO(dateStr);
    if (isValid(parsedISO)) {
      return dateStr;
    }

    const parsedDate = new Date(dateStr);
    return isNaN(parsedDate.getTime()) ? format(new Date(), 'yyyy-MM-dd') : parsedDate.toISOString();
  }

  getLastTrimesterPeriod() {
    const now = new Date();
    const currentMonth = format(now, 'M');
    const currentYear = format(now, 'yyyy');
    let begin: string;
    let end: string;

    if (+currentMonth < 4) {
      begin = currentYear + '-01';
      end = currentYear + '-03';
    } else if (+currentMonth < 7) {
      begin = currentYear + '-04';
      end = currentYear + '-06';
    } else if (+currentMonth < 10) {
      begin = currentYear + '-07';
      end = currentYear + '-09';
    } else {
      begin = currentYear + '-10';
      end = currentYear + '-12';
    }
    return {begin, end};
  }

  getElectronicDocumentTypes() {
    return this.electronicDocumentTypes;
  }
}
